import { render, staticRenderFns } from "./ProcessPage.vue?vue&type=template&id=2cc791bc&scoped=true&"
import script from "./processPage.ts?vue&type=script&lang=ts&"
export * from "./processPage.ts?vue&type=script&lang=ts&"
import style0 from "./ProcessPage.vue?vue&type=style&index=0&id=2cc791bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc791bc",
  null
  
)

export default component.exports